import Neighborhood from "../../entities/pak/Neighborhood";
import { INeighborhood } from "../../entities/pak/types";
import { IManhattanFactory } from "../manhattan/types";

export const PakNeighborhoodFactory: IManhattanFactory = class PakNeighborhoodFactory {

  static create(neighborhoods: INeighborhood[]) {
    return neighborhoods.map((neighborhood) => {
      return new Neighborhood(
        neighborhood.city,
        neighborhood.municipality,
        neighborhood.neighborhood
      );
    });
  }

};
